module.exports = window._net;